"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _excluded = ["alignCenter", "alignEnd", "children", "className", "lg", "lgHidden", "lgTextAlign", "md", "mdHidden", "mdTextAlign", "noBottomGutter", "noGutter", "noLeftGutter", "noRightGutter", "noTopGutter", "sm", "smHidden", "smTextAlign", "textAlign", "valignBottom", "valignCenter", "valignTop", "xl", "xlHidden", "xlTextAlign", "xs", "xsHidden", "xsTextAlign", "xxl", "xxlHidden", "xxlTextAlign"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CSS_PREFIX = 'col';
var ALIGNMENTS = ['center', 'left', 'right'];

var Col = function Col(_ref) {
  var _classnames;

  var alignCenter = _ref.alignCenter,
      alignEnd = _ref.alignEnd,
      children = _ref.children,
      className = _ref.className,
      lg = _ref.lg,
      lgHidden = _ref.lgHidden,
      lgTextAlign = _ref.lgTextAlign,
      md = _ref.md,
      mdHidden = _ref.mdHidden,
      mdTextAlign = _ref.mdTextAlign,
      noBottomGutter = _ref.noBottomGutter,
      noGutter = _ref.noGutter,
      noLeftGutter = _ref.noLeftGutter,
      noRightGutter = _ref.noRightGutter,
      noTopGutter = _ref.noTopGutter,
      sm = _ref.sm,
      smHidden = _ref.smHidden,
      smTextAlign = _ref.smTextAlign,
      textAlign = _ref.textAlign,
      valignBottom = _ref.valignBottom,
      valignCenter = _ref.valignCenter,
      valignTop = _ref.valignTop,
      xl = _ref.xl,
      xlHidden = _ref.xlHidden,
      xlTextAlign = _ref.xlTextAlign,
      xs = _ref.xs,
      xsHidden = _ref.xsHidden,
      xsTextAlign = _ref.xsTextAlign,
      xxl = _ref.xxl,
      xxlHidden = _ref.xxlHidden,
      xxlTextAlign = _ref.xxlTextAlign,
      remainingProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames2.default)(CSS_PREFIX, (_classnames = {}, _defineProperty(_classnames, "vds-text--".concat(textAlign), Boolean(textAlign)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--xs-").concat(xs), Boolean(xs)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--sm-").concat(sm), Boolean(sm)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--md-").concat(md), Boolean(md)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--lg-").concat(lg), Boolean(lg)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--xl-").concat(xl), Boolean(xl)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--xxl-").concat(xxl), Boolean(xxl)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--xs-hidden"), Boolean(xsHidden)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--sm-hidden"), Boolean(smHidden)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--md-hidden"), Boolean(mdHidden)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--lg-hidden"), Boolean(lgHidden)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--xl-hidden"), Boolean(xlHidden)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--xxl-hidden"), Boolean(xxlHidden)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--xs-text-").concat(xsTextAlign), Boolean(xsTextAlign)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--sm-text-").concat(smTextAlign), Boolean(smTextAlign)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--md-text-").concat(mdTextAlign), Boolean(mdTextAlign)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--lg-text-").concat(lgTextAlign), Boolean(lgTextAlign)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--xl-text-").concat(xlTextAlign), Boolean(xlTextAlign)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--xxl-text-").concat(xxlTextAlign), Boolean(xxlTextAlign)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--no-bottom-gutter"), Boolean(noBottomGutter)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--no-gutter"), Boolean(noGutter)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--no-left-gutter"), Boolean(noLeftGutter)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--no-right-gutter"), Boolean(noRightGutter)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--no-top-gutter"), Boolean(noTopGutter)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--align-end"), Boolean(alignEnd)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--align-center"), Boolean(alignCenter)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--valign-bottom"), Boolean(valignBottom)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--valign-center"), Boolean(valignCenter)), _defineProperty(_classnames, "".concat(CSS_PREFIX, "--valign-top"), Boolean(valignTop)), _classnames), className),
    "data-vds-col": true
  }, remainingProps), children);
};

Col.propTypes = {
  /**
   * alignCenter
   */
  alignCenter: _propTypes.bool,

  /**
   * alignEnd
   */
  alignEnd: _propTypes.bool,

  /**
   * Content
   */
  children: _propTypes.node,

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * Prefix for large screens
   */
  lg: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Hide at large screens
   */
  lgHidden: _propTypes.bool,

  /**
   * Text alignment at large screens
   */
  lgTextAlign: (0, _propTypes.oneOf)(ALIGNMENTS),

  /**
   * Prefix for medium screens
   */
  md: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8]),

  /**
   * Hide at medium screens
   */
  mdHidden: _propTypes.bool,

  /**
   * Text alignment at medium screens
   */
  mdTextAlign: (0, _propTypes.oneOf)(ALIGNMENTS),

  /**
   * hasNoBottomGutter
   */
  noBottomGutter: _propTypes.bool,

  /**
   * noGutter
   */
  noGutter: _propTypes.bool,

  /**
   * noLeftGutter
   */
  noLeftGutter: _propTypes.bool,

  /**
   * noRightGutter
   */
  noRightGutter: _propTypes.bool,

  /**
   * noTopGutter
   */
  noTopGutter: _propTypes.bool,

  /**
   * Prefix for small screens
   */
  sm: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8]),

  /**
   * Hide at small screens
   */
  smHidden: _propTypes.bool,

  /**
   * Text alignment at small screens
   */
  smTextAlign: (0, _propTypes.oneOf)(ALIGNMENTS),

  /**
   * Text alignment at all sizes
   */
  textAlign: (0, _propTypes.oneOf)(ALIGNMENTS),

  /**
   * valignBottom
   */
  valignBottom: _propTypes.bool,

  /**
   * valignCenter
   */
  valignCenter: _propTypes.bool,

  /**
   * valignTop
   */
  valignTop: _propTypes.bool,

  /**
   * Prefix for extra-large screens
   */
  xl: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Hide at extra-large screens
   */
  xlHidden: _propTypes.bool,

  /**
   * Text alignment at extra-large screens
   */
  xlTextAlign: (0, _propTypes.oneOf)(ALIGNMENTS),

  /**
   * Prefix for extra-small screens
   */
  xs: (0, _propTypes.oneOf)([1, 2, 3, 4]),

  /**
   * Hide at extra-small screens
   */
  xsHidden: _propTypes.bool,

  /**
   * Text alignment at extra-small screens
   */
  xsTextAlign: (0, _propTypes.oneOf)(ALIGNMENTS),

  /**
   * Prefix for extra extra large screens
   */
  xxl: (0, _propTypes.oneOf)([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Hide at extra-extra-large screens
   */
  xxlHidden: _propTypes.bool,

  /**
   * Text alignment at extra-extra-large screens
   */
  xxlTextAlign: (0, _propTypes.oneOf)(ALIGNMENTS)
};
Col.displayName = 'Col';
var _default = Col;
exports.default = _default;